import type { OwaDate, GlobalCalendarLocale } from 'owa-datetime';
import {
    lazyFormatIntlDate,
    lazyGetIntlMonth,
    lazyGetIntlYear,
} from 'owa-datetime-intl-formatters';

export function formatIntlDate(
    date: OwaDate | null | undefined,
    locale: GlobalCalendarLocale,
    format: string | null | undefined
): string {
    const formatIntlDateInternal = lazyFormatIntlDate.tryImportForRender();

    if (!formatIntlDateInternal) {
        return '';
    }

    return formatIntlDateInternal(date, locale, format);
}

export function getIntlMonth(
    date: OwaDate,
    locale: GlobalCalendarLocale,
    format: 'numeric' | '2-digit' | 'short' | 'long'
): string {
    const getIntlMonthInternal = lazyGetIntlMonth.tryImportForRender();

    if (!getIntlMonthInternal) {
        return '';
    }

    return getIntlMonthInternal(date, locale, format);
}

export function getIntlYear(
    date: OwaDate,
    locale: GlobalCalendarLocale,
    format: 'numeric' | '2-digit'
): string {
    const getIntlYearInternal = lazyGetIntlYear.tryImportForRender();

    if (!getIntlYearInternal) {
        return '';
    }

    return getIntlYearInternal(date, locale, format);
}
